import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Building2, Mail, Phone, MapPin } from 'lucide-react';

export const MentionsLegales = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-br from-black via-gray-900 to-black text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <button
            onClick={() => navigate('/')}
            className="flex items-center space-x-2 text-gray-300 hover:text-white mb-8 transition-colors"
          >
            <ArrowLeft size={20} />
            <span>Retour au site</span>
          </button>
          <h1 className="text-4xl md:text-5xl font-bold">Mentions Légales</h1>
          <p className="text-gray-300 mt-4">Informations légales du site</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 space-y-8">
          
          {/* Présentation du site internet */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
              <Building2 className="mr-3 text-blue-600" size={28} />
              1. Présentation du site internet
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                En vertu de l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, 
                il est précisé aux utilisateurs du site internet l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi:
              </p>
              <div className="bg-gray-50 p-6 rounded-lg space-y-2">
                <p><strong>Propriétaire :</strong> SAS K&O PHONELAB</p>
                <p><strong>Capital social :</strong> 2000€</p>
                <p><strong>Numéro de TVA :</strong> FR80890065071</p>
                <p><strong>Adresse :</strong> 5 rue Paul Verlaine 69100 Villeurbanne</p>
                <p><strong>Responsable publication :</strong> KOPHONELAB – kophonelab@gmail.com</p>
                <p><strong>Webmaster :</strong> K&O PHONELAB – kophonelab@gmail.com</p>
                <p><strong>Hébergeur :</strong> LWS – 10 rue Penthièvre 75008 Paris FRANCE (01 77 62 30 03)</p>
                <p><strong>Délégué à la protection des données :</strong> KOPHONELAB – kophonelab@gmail.com</p>
              </div>
            </div>
          </section>

          <hr className="border-gray-200" />

          {/* Conditions générales d'utilisation */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              2. Conditions générales d'utilisation du site et des services proposés
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Le Site constitue une œuvre de l'esprit protégée par les dispositions du Code de la Propriété Intellectuelle et des Réglementations Internationales applicables.
                Le Client ne peut en aucune manière réutiliser, céder ou exploiter pour son propre compte tout ou partie des éléments ou travaux du Site.
              </p>
              <p>
                L'utilisation du site K&O PHONELAB implique l'acceptation pleine et entière des conditions générales d'utilisation ci-après décrites. 
                Ces conditions d'utilisation sont susceptibles d'être modifiées ou complétées à tout moment, les utilisateurs du site sont donc invités à les consulter de manière régulière.
              </p>
              <p>
                Ce site internet est normalement accessible à tout moment aux utilisateurs. Une interruption pour raison de maintenance technique peut être toutefois décidée par K&O PHONELAB, 
                qui s'efforcera alors de communiquer préalablement aux utilisateurs les dates et heures de l'intervention.
              </p>
            </div>
          </section>

          <hr className="border-gray-200" />

          {/* Description des services */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              3. Description des services fournis
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Le site internet a pour objet de fournir une information concernant l'ensemble des activités de la société.
                K&O PHONELAB s'efforce de fournir sur le site des informations aussi précises que possible. 
                Toutefois, il ne pourra être tenu responsable des oublis, des inexactitudes et des carences dans la mise à jour, 
                qu'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.
              </p>
              <p>
                Toutes les informations indiquées sur le site sont données à titre indicatif, et sont susceptibles d'évoluer. 
                Par ailleurs, les renseignements figurant sur le site ne sont pas exhaustifs. 
                Ils sont donnés sous réserve de modifications ayant été apportées depuis leur mise en ligne.
              </p>
            </div>
          </section>

          <hr className="border-gray-200" />

          {/* Limitations techniques */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              4. Limitations contractuelles sur les données techniques
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Le site utilise la technologie JavaScript.
              </p>
              <p>
                Le site Internet ne pourra être tenu responsable de dommages matériels liés à l'utilisation du site. 
                De plus, l'utilisateur du site s'engage à accéder au site en utilisant un matériel récent, ne contenant pas de virus 
                et avec un navigateur de dernière génération mis-à-jour.
              </p>
              <p>
                Le site est hébergé chez un prestataire sur le territoire de l'Union Européenne conformément aux dispositions du 
                Règlement Général sur la Protection des Données (RGPD : n° 2016-679).
              </p>
            </div>
          </section>

          <hr className="border-gray-200" />

          {/* Propriété intellectuelle */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              5. Propriété intellectuelle et contrefaçons
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                K&O PHONELAB est propriétaire des droits de propriété intellectuelle et détient les droits d'usage sur tous les éléments accessibles sur le site internet, 
                notamment les textes, images, graphismes, logos, vidéos, icônes et sons.
              </p>
              <p>
                Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, 
                quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de K&O PHONELAB.
              </p>
              <p>
                Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient sera considérée comme constitutive d'une contrefaçon 
                et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.
              </p>
            </div>
          </section>

          <hr className="border-gray-200" />

          {/* Limitations de responsabilité */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              6. Limitations de responsabilité
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                <strong>K&O PHONELAB</strong> agit en tant qu'éditeur du site. K&O PHONELAB est responsable de la qualité et de la véracité du Contenu qu'il publie.
              </p>
              <p>
                K&O PHONELAB ne pourra être tenu responsable des dommages directs et indirects causés au matériel de l'utilisateur, 
                lors de l'accès au site internet, et résultant soit de l'utilisation d'un matériel ne répondant pas aux spécifications indiquées, 
                soit de l'apparition d'un bug ou d'une incompatibilité.
              </p>
              <p>
                K&O PHONELAB ne pourra également être tenu responsable des dommages indirects (tels par exemple qu'une perte de marché ou perte d'une chance) 
                consécutifs à l'utilisation du site.
              </p>
            </div>
          </section>

          <hr className="border-gray-200" />

          {/* Droit applicable */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              10. Droit applicable et attribution de juridiction
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Tout litige en relation avec l'utilisation du site est soumis au droit français.
                En dehors des cas où la loi ne le permet pas, il est fait attribution exclusive de juridiction aux tribunaux compétents de Lyon.
              </p>
            </div>
          </section>

        </div>

        {/* Back to site button */}
        <div className="text-center mt-8">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center space-x-2 bg-black text-white px-8 py-4 rounded-full font-semibold hover:bg-gray-800 transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            <ArrowLeft size={20} />
            <span>Retour au site</span>
          </button>
        </div>
      </div>
    </div>
  );
};